// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { FirstName, FirstNameSchema } from 'api/gen/FirstName';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { LastName, LastNameSchema } from 'api/gen/LastName';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PositiveInteger, PositiveIntegerSchema } from 'api/gen/PositiveInteger';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { Username, UsernameSchema } from 'api/gen/Username';

const requiredPart = t.interface({
  active: t.boolean,
  firstName: t.union([FirstNameSchema, t.null]),
  lastName: t.union([LastNameSchema, t.null]),
  registrationEmail: t.union([t.string, t.null]),
  userProfileId: PositiveIntegerSchema,
  username: UsernameSchema,
});

export const UserDetailSchema = excess(requiredPart);

export interface UserDetail extends t.TypeOf<typeof UserDetailSchema> {}
